export const getObjectWithoutFunctions = (incomingObject) => {
    const saveObject = {};
    Object.entries(incomingObject).forEach(([stateKey, stateValue]) => {
        if (typeof stateValue !== "function") {
            saveObject[stateKey] = stateValue;
        }
    });
    return saveObject
}